import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import DoneIcon from '../../GoogleIcons/Outlined/DoneIcon.js';
import MeetingRoom from '../../GoogleIcons/Outlined/MeetingRoom.js';
import Button from '../Button/Button.js';
import { NOOP } from '../../../utils/const.js';
import NavDropdown from '../../NavDropdown/NavDropdown.js';

const MenuUfficiItems = ({ uffici, ufficioSelezionato, onUfficioChange, }) => (jsx(Fragment, { children: uffici.map((ufficio) => (jsx(NavDropdown.Item, { onClick: ufficio !== ufficioSelezionato ? () => onUfficioChange(ufficio) : NOOP, children: jsxs(Button, { children: [jsx(MeetingRoom, {}), ' ', "Ufficio", ' ', ufficio, ufficioSelezionato === ufficio && jsx(DoneIcon, {})] }) }, ufficio))) }));
MenuUfficiItems.defaultProps = {
    ufficioSelezionato: null,
};

export { MenuUfficiItems as default };
